<template>
  <div class="row-txt-m">
    <div class="row-txt-header">{{ kpi ? kpi.KpiName : '' }}</div>
    <performanceitem  :overallByWave="getOverallByWave"
                      :kpi="kpi" />
  </div>
</template>

<script>
  import performanceitem from './PerformanceItem';
  import KpiMixin from '@/mixins/lambo/KpiMixin';

  export default {
    components: {
      performanceitem
    },

    mixins: [ KpiMixin ],

    props: {
      kpi: { type: Object }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/../scss/lambo/variables.scss";

  .row-txt-m {
    height: 100%;
    background-color: $lambo-header-color-alt;
    border-left:solid 1px $lambo-header-border;
    border-right:solid 1px $lambo-header-border;
  }

  .row-txt-header {
    text-align: center;
    font-weight: bold;
    height: 48px;
  }
</style>
